import { Card, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Icon from '@mdi/react';
import { Divider, Typography } from 'antd';
import React, { Fragment } from 'react'
import {
    mdiMotion, mdiBusStop,
    mdiBookMarker,
} from '@mdi/js';

const TimeLineSummaryItem = ({ trackData }) => {
    if (trackData && trackData.track && trackData.track.length > 0) {
        return (
            <Card>

                <ListItem>
                    <ListItemIcon>
                        <Icon
                            path={mdiBookMarker}
                            title="Start Address"
                            size={0.8}
                            color="DodgerBlue"
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary="Start Location"
                        secondary={trackData.track[0].address.net_addr}
                    />
                </ListItem>
                <Divider component="li" variant="inset" />
                <ListItem>
                    <ListItemIcon>
                        <Icon
                            path={mdiMotion}
                            title="Drive"
                            size={0.8}
                            color="ForestGreen"
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography variant="body2" color="textSecondary" component="p">
                                <b>Drive: </b> {`${trackData.meta.routeLength.toLocaleString('en-IN', { maximumFractionDigits: 1 })} Km (${trackData && trackData.drives.length} Segments)`}
                            </Typography>
                        }
                        secondary={
                            <Fragment>
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>Duration: </b> {`${trackData.meta.driveDuration}`}
                                </Typography>
                                <br />
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>Top Speed: </b> {`${trackData.meta.topSpeed.toLocaleString('en-IN', { maximumFractionDigits: 1 })} Km/h`}
                                </Typography>
                                <br />
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>Average Speed: </b> {`${trackData.meta.averageSpeed ? trackData.meta.averageSpeed.toLocaleString('en-IN', { maximumFractionDigits: 1 }) : 0} Km/h`}
                                </Typography>
                            </Fragment>
                        }
                    />
                </ListItem>
                <Divider component="li" variant="inset" />
                <ListItem>
                    <ListItemIcon>
                        <Icon
                            path={mdiBusStop}
                            title="Stop"
                            size={0.8}
                            color="GoldenRod"
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography variant="body2" color="textSecondary" component="p">
                                <b>Stops: </b> {`${trackData.meta.stopDuration} (${trackData && trackData.stops.length} Stops)`}
                            </Typography>
                        }
                    />
                </ListItem>
                <Divider component="li" variant="inset" />
                <ListItem>
                    <ListItemIcon>
                        <Icon
                            path={mdiBookMarker}
                            title="Live Map"
                            size={0.8}
                            color="Crimson"
                        />
                    </ListItemIcon>

                    <ListItemText
                        primary="End Location"
                        secondary={trackData && trackData.track[trackData.track.length - 1].address.net_addr}
                    />
                </ListItem>



            </Card>

        );
    } else {
        //console.log("Summary data issue");
        return null;
    }

}

export default TimeLineSummaryItem;